module.exports = __webpack_public_path__ + "static/media/solid-star.930d5446.svg";